import React from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { Button } from '@atlas/ui';

import BetChecker from './BetChecker';

const BetCheckerButton = ({ onClick }) => {
  const handleClick = () => {
    NotificationManager.display({
      data: {
        children: <BetChecker />,
      },
      title: 'bet_checker_title',
      type: 'fullscreen',
    });

    onClick?.();
  };

  return (
    <div className="bet-checker-button bet-checker-padding">
      <Button
        block
        icon="bet-checker"
        label="bet checker"
        onClick={handleClick}
        size="big"
        type="secondary"
      />
    </div>
  );
};

BetCheckerButton.propTypes = {
  onClick: PropTypes.func,
};

export default BetCheckerButton;
